import { useMutation } from "react-query";

import reservationsService from "api/reservationsService";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useUI } from "providers/UIProvider";

const useUpdateReservationStatusMutation = ()=> {
  const { T } = useUI()
  return useMutation(async(reservationId: number) => {
    const res = await reservationsService.updateReservationStatus(reservationId)

    return res.data
  }, {
    onError: (err: AxiosError<any>) => {
      toast.error(T(`${err.response?.data.MessageId}`) ||T("general.error"))
    }
  })
}

export default useUpdateReservationStatusMutation